import React from 'react';
import Helmet from 'react-helmet';
import { Router, Switch, Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'material-ui-snackbar-provider';
import { ConfirmProvider } from 'material-ui-confirm';
import { ThemeProvider } from '@material-ui/core/styles';
import { hot } from 'react-hot-loader';
import MomentUtils from '@date-io/moment';
import { SnackbarComponent } from 'hooks/useSnack';
import Home from './components/Home';
import Logout from './components/auth/Logout';
import Checkout from './modules/checkout';
import LeadForm from './modules/referral/LeadForm';
import { configureAmplify } from './Services';
import theme from './theme';

configureAmplify();

function App({ history }) {

  return (
    <React.Fragment>
      <Helmet titleTemplate="%s - WeAdmit" />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ConfirmProvider>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider
              SnackbarProps={{ autoHideDuration: 3000 }}
              SnackbarComponent={SnackbarComponent}
            >
              <Router history={history} >
                <Switch>
                  <Route path="/logout" component={Logout} />
                  <Route path="/checkout" component={Checkout} />
                  <Route path="/free-counseling" component={LeadForm} />
                  <Route path="/" component={Home} />
                </Switch>
              </Router>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </ConfirmProvider>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default hot(module)(App);
